"use client"

import { ListChevronsDownUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListChevronsDownUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListChevronsDownUpIcon = component(Icon)({
  as: ListChevronsDownUp,
})
